export default __webpack_public_path__ + "static/media/2010.6f69c22e.png";